import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// todo fix wraning
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
